const rankings = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店监控画面全网疯传', heat: '980万', trend: 'up', tag: '新' },
  { rank: 2, title: '知名女星前夫万字爆料长文：揭露十年婚姻不为人知的秘密', heat: '750万', trend: 'up', tag: '热' },
  { rank: 3, title: '某综艺导演被联合举报：多位艺人实名指控行业内幕', heat: '620万', trend: 'same', tag: '爆' },
  { rank: 4, title: '当红小生税务风波再起：官方回应疑点重重引发全网猜测', heat: '480万', trend: 'down', tag: '' },
  { rank: 5, title: '网红主播带货翻车事件升级：消费者集体诉讼最新进展', heat: '350万', trend: 'up', tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门榜单</h2>
          <div className="flex items-center gap-1 text-accent-500">
            <i className="ri-fire-fill"></i>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankings.slice(0, 3).map((item) => (
            <div
              key={item.rank}
              className="relative bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group"
            >
              {item.rank === 1 && (
                <div className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center bg-accent-500 rounded-full">
                  <i className="ri-vip-crown-fill text-background-50 text-sm"></i>
                </div>
              )}
              <div className="flex items-start gap-4">
                <span
                  className={`shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed line-clamp-2 font-medium">
                    {item.title}
                  </p>
                  <div className="flex items-center gap-3 mt-3">
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.heat}热度
                    </span>
                    {item.tag && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500/15 text-primary-500 font-medium">
                        {item.tag}
                      </span>
                    )}
                    {item.trend === 'up' && (
                      <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                    )}
                    {item.trend === 'down' && (
                      <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          {rankings.slice(3).map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 bg-background-100 rounded-lg px-4 py-3 border border-background-200/60 hover:border-primary-500/20 transition-all cursor-pointer group"
            >
              <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 font-bold text-sm">
                {item.rank}
              </span>
              <p className="flex-1 text-sm text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-1">
                {item.title}
              </p>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}热度</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}